import * as React from 'react';
import {Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {Contact} from '../api/dtos/dtos';
import locales from '../locales';
import InputFormItem from '../common/form-items/InputFormItem';
import SubmitCancelFormItem from '../common/form-items/SubmitCancelFormItem';
import {emailSuffix, phoneSuffix} from '../utils/form-utils';


interface ClientContactsFormProps extends FormComponentProps {
  emailRequired?: boolean;
  contact: Contact;
  onFormSubmit: (contact: Contact) => void;
  onFormCancel: () => void;
}

const FIELD_NAME = 'name';
const FIELD_TITLE = 'title';
const FIELD_TEL = 'tel';
const FIELD_EMAIL = 'email';
const FIELD_ID_NUMBER = 'idNumber';
const FIELD_MOTHERS_NAME = 'mothersName';

class ClientContactsForm extends React.Component<ClientContactsFormProps, {}> {

  public render() {
    const {form, contact, emailRequired} = this.props;
    return (
      <Form>
        <InputFormItem
          form={form}
          fieldId={FIELD_NAME}
          label={locales.name}
          initialValue={contact.name}
          required={true}
        />
        <InputFormItem
          form={form}
          fieldId={FIELD_EMAIL}
          label={locales.email}
          initialValue={contact.email}
          rules={[{type: 'email', message: locales.email_invalid,}]}
          type="email"
          required={emailRequired ?? false}
          addonAfter={contact.email && emailSuffix(contact.email)}
        />
        <InputFormItem
          form={form}
          fieldId={FIELD_TITLE}
          label={locales.title}
          initialValue={contact.title}
          required={false}
        />
        <InputFormItem
          form={form}
          fieldId={FIELD_TEL}
          label={locales.tel}
          initialValue={contact.tel}
          type="tel"
          required={false}
          addonAfter={contact.tel && phoneSuffix(contact.tel)}
        />
        <InputFormItem
          form={form}
          fieldId={FIELD_ID_NUMBER}
          label={locales.id_number}
          initialValue={contact.idNumber}
          required={false}
        />
        <InputFormItem
          form={form}
          fieldId={FIELD_MOTHERS_NAME}
          label={locales.mothers_name}
          initialValue={contact.mothersName}
          required={false}
        />
        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {contact, form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit({
          ...contact,
          name: values[FIELD_NAME],
          title: values[FIELD_TITLE],
          tel: values[FIELD_TEL],
          email: values[FIELD_EMAIL],
          idNumber: values[FIELD_ID_NUMBER],
          mothersName: values[FIELD_MOTHERS_NAME],
        });
      }
    });
  };
}

export default Form.create<ClientContactsFormProps>()(ClientContactsForm);



// WEBPACK FOOTER //
// ./src/client-details/ClientContactForm.tsx